import { HeaderFooterMachCore } from '../../models/header-footer-mach-core';
import { TripTypeOptions } from '../../models/header-footer-mach-core/book-widget-aem.interfaces';

export const HEADER_FOOTER_MOCKS: HeaderFooterMachCore = {
  header: {
    book: {
      cars: {
        locationContent: {
          label: 'Location',
          placeholder: 'Pickup',
          accessibilityLocation: 'Search car rental location'
        },
        searchOptions: {
          placeHolderLabel: 'Search'
        },
        pickUpDate: {
          title: 'Pick Up'
        },
        pickUpTimeDropdown: {
          placeholder: '10:00am',
          icon: '/content/dam/delta-applications/ui-kit/assets/svg/booking-widget/wait-time.svg'
        },
        dropOffDate: {
          title: 'Drop Off'
        },
        dropOffTimeDropdown: {
          placeholder: '10:00am',
          icon: '/content/dam/delta-applications/ui-kit/assets/svg/booking-widget/wait-time.svg'
        },
        labels: {
          pickUpLabel: 'Pick Up',
          pickUpTimeLabel: '10:00am',
          dropOffLabel: 'Drop Off',
          dropOffTimeLabel: '10:00am',
          buttonLabel: 'Find Cars',
          viewSearchOptionsLabel: 'View Search Options'
        },
        accessibility: {
          locationAriaLabel: 'Search car rental location',
          pickUpAriaLabel: 'Select pick up date',
          pickUpTimeAriaLabel: 'Select pick up time',
          dropOffAriaLabel: 'Select drop off date',
          dropOffTimeAriaLabel: 'Select drop off time',
          buttonAriaLabel: 'Search for car rentals'
        },
        error: {
          errorBannerMessage:
            "We're sorry, there was a problem with your search. Go to <a class='text-link' href='https://carsandstays.delta.com/?MDPCID=Delta-US.DPS.Delta.Homepage-Bellyband.AllLOB#' target='_blank'>Delta Cars</a> and try searching again.",
          errorMessage: 'To continue, please correct the',
          locationErrorMessage: 'Destination is required',
          dateErrorMessage: 'Date is required',
          dateSelectionErrorMessage:
            'Please select a drop-off date that is on or after the pickup-up date',
          dateRangeErrorMessage: 'Dates must be no more than 30 days apart.',
          timeRangeErrorMessage:
            'Adjust your date and time to ensure there is at least 2 hour difference between pick-up and drop-off.',
          pickupTimePassedErrorMessage:
            'The pick-up time must be after the current time.',
          dropoffTimePassedErrorMessage:
            'The drop-off time must be after the current time.',
          predictiveCitiesNoResults:
            "We're sorry , there was a problem with your search . Go to Delta Cars and try searching again",
          dropOffBeforePickupMessage:
            'Please select a drop-off time after pickup time'
        }
      },
      stays: {
        locationContent: {
          label: 'Location',
          placeholder: 'Destination',
          accessibilityLocation: 'Search available stay location'
        },
        searchOptions: {
          placeHolderLabel: 'Search'
        },
        airportModalContent: {
          airportList: {
            id: 'stays-search-transparent',
            title: 'Destination',
            placeholder: 'Search location...',
            hasExternalFiltering: true,
            shouldAutoCapitalize: true,
            menuVariant: 'transparent',
            hasAutocomplete: false,
            items: []
          },
          mobileCloseHeaderText: 'Select Origin',
          floatingLabelText: 'Destination'
        },
        dropDownDateOption: {
          id: 'range-date-picker',
          title: 'Check In - Out',
          selectionType: 'range',
          positionElement: 'range-date-trigger',
          footer: {
            primaryButtonLabel: 'Done'
          }
        },
        dropDownTravelerOption: {
          id: 'dropdownTraveler',
          placeholder: 'Select a Traveler',
          icon: '/content/dam/delta-applications/ui-kit/assets/svg/booking-tab/passenger.svg',
          items: [
            {
              label: '1 Traveler',
              value: '1'
            },
            {
              label: '2 Travelers',
              value: '2'
            },
            {
              label: '3 Travelers',
              value: '3'
            },
            {
              label: '4 Travelers',
              value: '4'
            },
            {
              label: '5 Travelers',
              value: '5'
            },
            {
              label: '6 Travelers',
              value: '6'
            },
            {
              label: '7 Travelers',
              value: '7'
            },
            {
              label: '8 Travelers',
              value: '8'
            },
            {
              label: '9 Travelers',
              value: '9'
            },
            {
              label: '10 Travelers',
              value: '10'
            },
            {
              label: '11 Travelers',
              value: '11'
            },
            {
              label: '12 Travelers',
              value: '12'
            },
            {
              label: '13 Travelers',
              value: '13'
            },
            {
              label: '14 Travelers',
              value: '14'
            }
          ]
        },
        dropDownRoomOption: {
          id: 'dropdownRoom',
          placeholder: 'Select a Room',
          icon: '/content/dam/delta-applications/ui-kit/assets/svg/booking-tab/hotels.svg',
          items: [
            {
              label: '1 Room',
              value: '1'
            },
            {
              label: '2 Rooms',
              value: '2'
            },
            {
              label: '3 Rooms',
              value: '3'
            },
            {
              label: '4 Rooms',
              value: '4'
            },
            {
              label: '5 Rooms',
              value: '5'
            },
            {
              label: '6 Rooms',
              value: '6'
            },
            {
              label: '7 Rooms',
              value: '7'
            },
            {
              label: '8 Rooms',
              value: '8'
            }
          ]
        },
        labels: {
          startDate: 'Check In',
          endDate: 'Out',
          findButton: 'Find Stays',
          viewSearchOptions: 'View Search Options',
          destinationErrorLabel: 'Destination is Required',
          datesAreRequiredErrorLabel: 'Dates are Required',
          maxDatesErrorLabel: 'Dates must be no more than 28 days apart',
          tooFewPeopleErrorLabel: 'Too few people',
          tooFewRoomsErrorLabel: 'Too few rooms',
          errorMessage: 'To continue, please correct the'
        },
        accessibility: {
          findButtonAriaLabel: 'Find available stays'
        },
        mdpcid: 'Delta.Site.US.HomepageWidget.Hotel.WidgetTestWhite'
      },
      vacations: {
        airportPicker: {
          origin: {
            fromLabel: 'From',
            placeHolderLabel: 'Origin'
          },
          destination: {
            toLabel: 'To',
            placeHolderLabel: 'Destination'
          },
          labels: {
            closeHeaderLabel: 'Select #',
            floatingLabel: 'Destination',
            searchAirportLabel: 'Search airports...'
          }
        },
        searchOptions: {
          placeHolderLabel: 'Search'
        },
        passengers: {
          placeholderLabel: 'Select a Passenger',
          options: [
            {
              passengerTitle: '1 Passenger',
              passengerId: '1'
            },
            {
              passengerTitle: '2 Passengers',
              passengerId: '2'
            },
            {
              passengerTitle: '3 Passengers',
              passengerId: '3'
            },
            {
              passengerTitle: '4 Passengers',
              passengerId: '4'
            },
            {
              passengerTitle: '5 Passengers',
              passengerId: '5'
            },
            {
              passengerTitle: '6 Passengers',
              passengerId: '6'
            },
            {
              passengerTitle: '7 Passengers',
              passengerId: '7'
            },
            {
              passengerTitle: '8 Passengers',
              passengerId: '8'
            },
            {
              passengerTitle: '9 Passengers',
              passengerId: '9'
            }
          ],
          icon: '/content/dam/delta-applications/ui-kit/assets/svg/booking-tab/passenger.svg'
        },
        rooms: {
          placeholderLabel: 'Select a Room',
          options: [
            {
              roomTitle: '1 Room',
              roomsId: '1'
            },
            {
              roomTitle: '2 Rooms',
              roomsId: '2'
            },
            {
              roomTitle: '3 Rooms',
              roomsId: '3'
            },
            {
              roomTitle: '4 Rooms',
              roomsId: '4'
            }
          ],
          icon: '/content/dam/delta-applications/ui-kit/assets/svg/booking-tab/hotels.svg'
        },
        dates: {
          placeHolderLabel: 'Depart - Return'
        },
        labels: {
          buttonLabel: 'Search',
          viewSearchOptionsLabel: 'View Search Options',
          originAndDestinationErrorLabel: 'Origin and Destination are Required',
          originErrorLabel: 'Origin is Required',
          destinationErrorLabel: 'Destination is Required',
          selectDifferentAirportErrorLabel:
            'Origin cannot be same as destination',
          datesAreRequiredErrorLabel: 'Dates are Required',
          tooFewPeopleErrorLabel: 'Too few people',
          maxDatesErrorLabel: 'Dates must be no more than 28 days apart',
          startDate: 'Depart',
          endDate: 'Return'
        },
        accessibility: {
          buttonAriaLabel: 'Search for vacation packages'
        },
        error: {
          errorBannerMessage:
            "We're sorry, there was a problem. Go to  <a class='text-link' href='/us/en/delta-vacations' target='_blank'>Delta Vacations</a> and try searching again.",
          pleaseCorrectErrorMessage: 'To continue, please correct the'
        }
      },
      bellyBand: {
        id: 'booking-tabs',
        bookingTab: {
          flightsText: 'Flights',
          staysText: 'Stays',
          carsText: 'Cars',
          vacationsText: 'Vacations',
          cruisesText: 'Cruises'
        },
        externalLinks: {
          text: {
            deltaAmexCard: 'Delta AMEX Cards',
            giftCards: 'Gift Cards',
            updateBagTravelFees: 'Updated Bags & Travel Fees'
          },
          links: {
            deltaAmexCard: 'https://www.delta.com/homeband2',
            giftCard: '/us/en/gift-cards/overview?icid=HPBelband',
            updateBagTravelFees: '/us/en/baggage/overview'
          },
          accessibility: {
            altText:
              'This link opens another site in a new window that may not follow the same accessibility policies as Delta Air Lines.'
          }
        }
      },
      bookWidget: {
        advancedSearchBtn: 'Advanced Search',
        airportsField: {
          addFlight: 'Add Flight',
          connectionLabel: 'Connection (Optional)',
          departureAriaLabel: 'Departure Airport or City',
          destinationAriaLabel: 'Destination Airport or City',
          flight: 'Flight',
          from: 'From',
          infoModal: {
            description:
              'Providing a connection airport will limit your results to flights that connect through the specified airport. Results will also be limited to those that have connections within our maximum connect times - four hours for a domestic trip, and twenty-four hours for an international trip.\u003Cbr\u003E\u003Cbr\u003EIf you would like to stay longer in the connecting city, or cannot find results when providing a connection city, please remove the connection city and search again.',
            title: 'Connection Airport'
          },
          originAriaLabel: 'Origin Airport or City',
          removeFlight: 'Remove Flight',
          searchModal: {
            connectionAirportLabel: 'Connection Airport',
            destinationLabel: 'Destination',
            originLabel: 'Origin',
            recentSearch: 'Recent Search',
            savedSearch: 'Saved Search',
            searchLabel: 'Search',
            selectLabel: 'Select',
            to: 'to'
          },
          swapAriaLabel: 'Reverse Origin and Destination Airport or City',
          to: 'To',
          yourDestination: 'Destination',
          yourOrigin: 'Origin'
        },
        bestFareOptionsField: {
          bestFare: 'Best Fares For',
          infoModal: {
            description:
              'Delta\'s proud to offer a variety of in-flight experiences tailored to your needs. Explore Delta’s \u003Ca href="/us/en/onboard/overview"\u003E\u003Cstrong\u003EOnboard Experience\u003C/strong\u003E\u003C/a\u003E options to see what awaits you on your next flight.',
            title: 'Onboard Experiences'
          }
        },
        datesField: {
          chooseDatesLabel: 'Choose Dates',
          datesAriaLabel: 'Flight Date Field',
          depart: 'Depart',
          departAriaLabel: 'DepartDate',
          return: 'Return',
          returnAriaLabel: 'ReturnDate'
        },
        defaultValues: {
          basicFaresChecked: 'true',
          bestFareOptions: [
            {
              brandID: 'BE',
              brandName: 'Delta Main Basic'
            },
            {
              brandID: 'MAIN',
              brandName: 'Delta Main'
            },
            {
              brandID: 'DCP',
              brandName: 'Delta Comfort'
            },
            {
              brandID: 'FIRST',
              brandName: 'Delta First'
            },
            {
              brandID: 'DPPS',
              brandName: 'Delta Premium Select'
            },
            {
              brandID: 'D1',
              brandName: 'Delta One®'
            }
          ],
          maxPaxCount: '9',
          selectTripType: TripTypeOptions.ROUND_TRIP,
          selectedPaxValue: '1',
          showBasicFares: 'true',
          tripTypeOptions: [
            TripTypeOptions.ROUND_TRIP,
            TripTypeOptions.ONE_WAY,
            TripTypeOptions.MULTI_CITY
          ]
        },
        edocsLink: 'Use Certificates, eCredits, or Delta Gift Cards',
        errorMessages: {
          SBW008: {
            message: 'Date is Required',
            singleMessage: ''
          },
          SBW009: {
            message: 'Dates are Required',
            singleMessage: ''
          },
          SBW010: {
            message: 'Departure date needs to be before return date',
            singleMessage: ''
          },
          SBW011: {
            message: 'Destination is Required',
            singleMessage: ''
          },
          SBW012: {
            message: 'Origin is Required',
            singleMessage: ''
          },
          SBW013: {
            message: 'Origin and Destination are Required',
            singleMessage: ''
          },
          SBW014: {
            message: 'Select Different Airport',
            singleMessage: ''
          },
          SBW015: {
            message: 'Valid city code or airport name is required',
            singleMessage: ''
          },
          SBW016: {
            message:
              'Select different airports for Departure, Destination and Connection',
            singleMessage: ''
          },
          SBW017: {
            message: 'Valid Meeting Code is required',
            singleMessage: ''
          },
          SBW018: {
            message:
              'To continue, please correct the {{errorCount}} items indicated.',
            singleMessage: 'To continue, please correct the 1 item indicated.'
          }
        },
        excludeBasicField: {
          excludeBasic: 'Exclude Main Basic'
        },
        flexAirportsField: {
          flexAirports: 'Include Nearby Airports'
        },
        flexDatesField: {
          flexDates: 'My Dates are Flexible'
        },
        helpIconAriaLabel: 'Help Icon',
        includeBasicField: {
          includeBasic: 'Include Basic'
        },
        meetingEventCodeField: {
          edpMeetingCodeDisclaimer: '',
          edpMeetingCodeDisclaimerForFare:
            'Proceeding with a Meeting/Event Code associated with this booking will prevent you from receiving corporate negotiated fares.',
          edpMeetingCodeDisclaimerForNoProgram: '',
          edpMeetingCodeDisclaimerForProgram:
            'Proceeding with a Meeting/Event code associated with this booking will prevent you from earning on behalf of your corporate rewards program.',
          infoModal: {
            description:
              'To locate your Meeting Event Code please contact your Meeting/Event coordinator or visit the organization’s travel page website.',
            title: 'Where Can I Find My Meeting Event Code?'
          },
          meetingEventCode: 'Meeting Code (Optional)',
          placeholder: 'ie. NMRMU'
        },
        passengerField: {
          passenger: 'Passenger',
          passengerAriaLabel: 'Passenger Count',
          passengersLabel: 'Passengers'
        },
        refundableFareField: {
          infoModal: {
            description:
              '\u003Cp\u003ECheck the checkbox to search for refundable fares:\u003C/p\u003E\u003Cul\u003E\u003Cli\u003EIf your travel plans change, you can view options to \u003Ca href="/refunds/refundsHomeAction.action"\u003E\u003Cstrong\u003Ecancel or refund flights\u003C/strong\u003E\u003C/a\u003E online.\u003C/li\u003E\u003Cli\u003EThey are generally offered on every flight, every day.\u003C/li\u003E\u003Cli\u003EYou can change or cancel your itinerary without paying a change fee, though you may need to pay the fare difference between the new and the old itineraries.\u003C/li\u003E\u003Cli\u003ERefunds are returned to your original form of payment.\u003C/li\u003E\u003C/ul\u003E\u003Cp\u003ENonrefundable fares are more restrictive:\u003C/p\u003E\u003Cul\u003E\u003Cli\u003EFor trips originating outside of North America, nonrefundable fares (Main Cabin and above) are subject to a $200 - $500 cancellation or change fee.\u003C/li\u003E\u003Cli\u003EIf you change your flight (such as your flight date, routing, origin or destination), you may need to pay the difference in price between your new and old flight.\u003C/li\u003E\u003Cli\u003EFunds for cancelled tickets or fare differences are provided via eCredit.\u003C/li\u003E\u003Cli\u003EWith most&nbsp;\u003Ca href="/us/en/onboard/onboard-experience/basic-economy"\u003E\u003Cstrong\u003EBasic fares\u003C/strong\u003E\u003C/a\u003E, changes and refunds are not permitted after the&nbsp;\u003Ca href="/us/en/change-cancel/cancel-flight#24hour"\u003E\u003Cstrong\u003ERisk-Free Cancellation\u003C/strong\u003E\u003C/a\u003E&nbsp;period. Your Cancellation may be permitted before departure for a cancellation charge. Exceptions may apply when flying out of some countries in Europe.\u003C/li\u003E\u003C/ul\u003E\u003Cp style="text-align: right;"\u003EView the full \u003Ca href="/us/en/change-cancel/overview"\u003E\u003Cstrong\u003Echange and cancellation policy here\u003C/strong\u003E\u003C/a\u003E.\u003C/p\u003E',
            title: 'Refundable'
          },
          refundableOnly: 'Refundable Fares Only'
        },
        searchBtn: 'Find Flights',
        shopMilesField: {
          shopWithMiles: 'Shop with Miles'
        },
        tripTypesField: {
          multiCity: 'Multi-City',
          onwWay: 'One Way',
          roundTrip: 'Round Trip',
          tripTypeAriaLabel: 'Trip Type'
        },
        viewSearchOptionsBtn: 'View Search Options'
      }
    },
    check_in: {
      checkInForm: {
        dropDownData: [
          {
            label: 'Confirmation Number',
            pattern: '^[a-zA-Z0-9]+$',
            placeHolder: 'ex. SFTORB',
            value: 'Confirmation Number',
            inputLabel: 'Confirmation Number*'
          },
          {
            label: 'Credit Card Number',
            pattern: '^[0-9]+$',
            placeHolder: 'ex. 1234123412341234',
            value: 'Credit Card Number',
            inputLabel: 'Credit Card Number*'
          },
          {
            label: 'Ticket Number',
            pattern: '^[0-9]+$',
            placeHolder: 'ex. 0062112549881',
            value: 'Ticket Number',
            inputLabel: 'Ticket Number*'
          },
          {
            label: 'SkyMiles Number',
            pattern: '^[0-9]+$',
            placeHolder: 'ex. 9876543210',
            value: 'SkyMiles Number',
            inputLabel: 'SkyMiles Number*'
          }
        ],
        toolTipData: [
          {
            description:
              'Look for your 6 characters (example SFTORB) confirmation number in the confirmation/receipt email you received after purchasing your ticket.',
            title: 'Where to locate a Confirmation Number?'
          },
          {
            description:
              'Look for your 13-digits (example 0062112549881) Ticket number in the confirmation/receipt email you received after purchasing your ticket.',
            title: 'Where to locate a Ticket Number?'
          }
        ],
        findYourTripByLabel: 'Find Your Trip By',
        submitUrl: '/PCCOciWeb/app/index.html',
        errorMessages: {
          confirmationNumber: {
            invalid: 'Please enter a valid Confirmation Number',
            required: 'Please enter a Confirmation Number'
          },
          creditCardNumber: {
            invalid: 'Please enter a valid Card Number',
            required: 'Please enter a Card Number'
          },
          fromCity: {
            invalid: 'Please enter a valid Departure City',
            required: 'Please enter a Departure City'
          },
          last_Name: {
            invalid: 'Please enter a valid Last Name',
            required: 'Please enter a Last Name'
          },
          skymiles: {
            invalid: 'Please enter a valid SkyMiles Number',
            required: 'Please enter a Skymiles Number'
          },
          ticketNumber: {
            invalid: 'Please enter a valid Ticket Number',
            required: 'Please enter a Ticket Number'
          }
        },
        errorText: {
          title: 'To continue, please correct the ',
          subTitle: ' items indicated'
        },
        fromAirport: {
          label: 'from Airport',
          ariaLabel: 'From Airport'
        },
        lastName: {
          label: 'Last Name',
          ariaLabel: 'ex. Smith'
        },
        search: {
          label: 'Search',
          searchAirportLabel: 'Search airports...',
          searchTitle: 'Origin',
          mobileCloseHeaderText: 'Select Airport',
          ariaLabel: 'City or Airport'
        }
      }
    },
    my_trips: {
      ancillaryLinks: {
        carReservation: {
          label: 'Delta Car Rentals',
          target: 'on',
          url: 'https://www.travelextras-delta.com/initiateSessionValidation?rurl=/trips?MDPCID=Delta.TopHomeMenu.US.Link.Car.Carreservationlink'
        },
        findMyTrips: 'Find My Trips',
        hotelReservation: {
          label: 'Delta Stays',
          target: 'false',
          url: 'https://www.travelextras-delta.com/initiateSessionValidation?rurl=/trips?MDPCID=Delta.TopMenu.US.Link.Lodging.FindItin#'
        },
        viewAllTrips: 'View All Trips COUNT'
      },
      backToUpcomingTripLabel: 'Back to Your Upcoming Trips',
      dataList: [
        {
          default: 'true',
          helpIcon: 'true',
          label: 'Confirmation Number*',
          mandatoryError: 'Please Enter a Confirmation Number.',
          patternError: 'Please Enter a valid Confirmation Number.',
          placeHolder: 'ex. SFTORB',
          popup: {
            alt: 'Confirmation Number Help',
            description:
              'Search for your trip using the confirmation number for any item (Flight, Car or Delta Vacations) purchased from delta.com. Confirmation numbers can be found on the confirmation receipt you received after your purchase.',
            id: 'confirmation-number',
            title: 'Confirmation Number'
          },
          title: 'Confirmation Number*',
          using: 'widgetSearchUsingConfirmationNo',
          value: 'confirmationNo',
          fieldType: 'text'
        },
        {
          default: 'false',
          helpIcon: 'false',
          label: 'Credit/Debit Card Number',
          mandatoryError: 'Please Enter a Card Number.',
          patternError: 'Please Enter a valid Card Number.',
          placeHolder: 'ex. 1234123412341234',
          popup: {
            alt: '',
            description: '',
            id: '',
            title: ''
          },
          title: 'Credit Card Number*',
          using: 'widgetSearchUsingCreditDebitNo',
          value: 'creditCardNo',
          fieldType: 'number'
        },
        {
          default: 'false',
          helpIcon: 'true',
          label: 'Ticket Number',
          mandatoryError: 'Please Enter a Ticket Number.',
          patternError: 'Please Enter a valid Ticket Number.',
          placeHolder: 'ex. 0062112549881',
          popup: {
            alt: 'Eticket Number Help',
            description:
              'Look for your 13-digit (example 0062112549881) Ticket number in the confirmation/receipt email you received after purchasing your ticket.',
            id: 'ticket-number',
            title: 'Where to locate a Ticket Number?'
          },
          title: 'Ticket Number*',
          using: 'widgetSearchUsingETicketNo',
          value: 'eTicketNo',
          fieldType: 'number'
        }
      ],
      errors: [
        {
          errorId: 'IROP_EXC',
          errorMessageDescription:
            'Please contact Delta Reservations at 800-221-1212 for assistance.',
          errorMessageTitle: 'There has been a change to your trip.'
        },
        {
          errorId: 'IROP_EXC_STN',
          errorMessageDescription:
            'Please contact your local reservation office for assistance.',
          errorMessageTitle: 'There has been a change to your trip.'
        },
        {
          errorId: 'IRP_impact',
          errorMessageDescription: 'There has been a change to your trip.',
          errorMessageTitle: 'There has been a change to your trip.'
        },
        {
          errorId: 'NO_TRIPS_AVAIL',
          errorMessageDescription: 'You do not have any upcoming trips',
          errorMessageTitle: 'You do not have any upcoming trips'
        },
        {
          errorId: 'SYS_ERROR',
          errorMessageDescription:
            'We’re unable to display your trips at this time. Please try again later.',
          errorMessageTitle:
            'We’re unable to display your trips at this time. Please try again later.'
        },
        {
          errorId: 'UPC_SYS_ERR',
          errorMessageDescription:
            "We're sorry, but we are unable to find your reservation. Please try again in <a class='link' href='/my-trips/search' target='_blank'>My Trips</a>.",
          errorMessageTitle:
            "We're sorry, but we are unable to find your reservation. Please try again in <a class='link' href='/my-trips/search' target='_blank'>My Trips</a>."
        },
        {
          errorId: 'DLYD',
          errorMessageDescription: 'There has been a change to your trip.',
          errorMessageTitle: 'There has been a change to your trip.'
        },
        {
          errorId: 'CXLD',
          errorMessageDescription: 'There has been a change to your trip.',
          errorMessageTitle: 'There has been a change to your trip.'
        },
        {
          errorId: 'TDY_SYS_ERR',
          errorMessageDescription:
            "We're sorry. Your next trip cannot be displayed at this time. Please try again later.",
          errorMessageTitle:
            "We're sorry. Your next trip cannot be displayed at this time. Please try again later."
        }
      ],
      findYourTripBy: 'Find Your Trip By',
      formError: 'To continue, please correct the',
      headerPciChanges: 'true',
      id: 'trips_sitewide',
      label: 'MY TRIPS',
      legacyAppUrl: '/mytrips/',
      linkActionAria: 'Opens in a new tab',
      nameList: [
        {
          label: 'First Name',
          mandatoryError: 'Please Enter a First Name.',
          patternError: 'Please Enter a valid First Name.',
          placeHolder: 'First Name',
          title: 'First Name',
          value: 'firstName',
          fieldType: 'text'
        },
        {
          label: 'Last Name',
          mandatoryError: 'Please Enter a Last Name.',
          patternError: 'Please Enter a valid Last Name.',
          placeHolder: 'Last Name',
          title: 'Last Name',
          value: 'lastName',
          fieldType: 'text'
        }
      ],
      redirectMobile: 'false',
      redirectMobileUrl: '',
      searchUrl: '',
      submitUrl: '/mytrips/',
      searchCTA: 'Search',
      tripDetails: {
        carReservationTitle: 'Your Car Reservation',
        checkIn: 'Check In',
        deltaVacationTitle: 'Your Delta Vacation',
        upComingTripTitle: 'Your Upcoming Trips',
        viewBoardingPass: 'View Boarding Pass',
        viewTripDetails: 'View Trip Details'
      }
    },
    flight_status: {
      id: 'flightstatus',
      label: 'FLIGHT STATUS',
      searchByLabel: 'Search By Date*',
      searchByLabelFloat: 'Search By Date',
      flightNumber: 'ex. 1049',
      flightNumberType: 'number',
      flightNumberLabelFloat: 'Flight Number*',
      orLabel: 'or',
      toLabel: 'To',
      toLabelFloat: 'To Airport',
      fromLabel: 'From',
      fromLabelFloat: 'From Airport',
      submitUrl: '/content/www/en_US/#/',
      legacyAppUrl: '/flightstatus/',
      searchUrl: '',
      tooltipdetails: [
        {
          itemId: 'flight-number',
          toolTipType: 'popup',
          toolTipTitle: 'Flight Number',
          toolTipDescription: 'Flight Number',
          toolTipDisclaimer: ''
        }
      ],
      helpUrl: '',
      helpLabel: '',
      redirectMobile: 'false',
      redirectMobileUrl: '',
      flightStatusSubmitUrl: '/flightstatus/1/',
      flightScheduleSubmitUrl: '/flightstatus/schedule/',
      flightstatusRegexPattern: '[0-9]*',
      errorMessages: {
        flightNumber: {
          required:
            'Please enter a valid Flight Number. If you do not know the flight number, please enter the origin and destination.',
          invalid: 'Please enter a valid Flight Number'
        },
        departureDate: {
          required: 'Please enter a flight date',
          invalid: 'Please enter a valid flight Date'
        },
        fromCity: {
          required: 'Please enter a Departure City',
          invalid: 'Please enter a valid City Code or Airport Name'
        },
        toCity: {
          required: 'Please enter a Destination City',
          invalid: 'Please enter a valid City Code or Airport Name'
        },
        sameAirport: {
          invalid: 'Origin cannot be same as destination'
        }
      },
      errorText: {
        title: 'To continue, please correct the ',
        subTitle: ' items indicated'
      },
      labels: {
        findButton: 'Search',
        viewSearchOptions: 'View Search Options'
      },
      accessibility: {
        formAriaLabel: 'Flight status search form',
        errorSectionAriaLabel: 'Form validation errors',
        searchButtonAriaLabel: 'Search for flight status',
        flightNumberAriaLabel: 'Flight Number',
        departureDateAriaLabel: 'Departure Date',
        originAriaLabel: 'From Airport',
        destinationAriaLabel: 'To Airport',
        swapAirportsAriaLabel: 'Swap origin and destination airports'
      }
    },
    primaryNavigation: [
      {
        id: 'book',
        label: 'Book',
        legacyAppUrl: '/flightsearch/book-a-flight',
        redirectMobile: 'false',
        redirectMobileUrl: '',
        searchUrl: ''
      },
      {
        id: 'check_in',
        label: 'Check-in',
        legacyAppUrl: '/PCCOciWeb/findBy.action',
        redirectMobile: 'false',
        redirectMobileUrl: '',
        searchUrl: ''
      },
      {
        id: 'my_trips',
        label: 'My Trips',
        legacyAppUrl: '/mytrips/',
        redirectMobile: 'false',
        redirectMobileUrl: ''
      },
      {
        id: 'flightstatus',
        label: 'Flight Status',
        legacyAppUrl: '/flightstatus/',
        redirectMobile: 'false',
        redirectMobileUrl: '',
        searchUrl: ''
      }
    ],
    trackerStaticText: {
      currentStatusLabel: 'Current Status:',
      trackerStaticDescription:
        'Explore the SkyMiles Overview page to see your current benefits, account activity, promotions and more.',
      exploreSkymilesButtonLabel: 'Explore My SkyMiles',
      exploreSkymilesLink: '/myskymiles/overview',
      upcomingTrackerButtonLabel: 'Learn More',
      upcomingTrackerDescription:
        'Explore the new SkyMiles program changes for earning your 2025 Medallion Status.',
      upcomingTrackerStartDate: '2024-01-01',
      upcomingTrackerEndDate: '2024-01-05',
      upcomingTrackerTimeFormat: 'T12:00:00Z',
      upcomingTrackerButtonUrl:
        '/global/en/skymiles/medallion-program/2024-program-updates',
      displayUpcomingTracker: 'false',
      showStaticTracker: 'false'
    },
    clearGifImage: '/content/dam/delta-applications/header/clear.gif',
    flyoutLanguageSelectorLinkLabel: 'Select other Location and Language',
    secondaryNavigation: [
      {
        id: 'secondarynav',
        label: 'Travel Info',
        pagePath: '/en_US/traveling-with-us-HPR',
        details: {
          mainNavigation: [
            {
              brandLabel: 'Delta One®',
              targetUrl: '/us/en/onboard/onboard-experience/delta-one',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/cabin/delta-one-cabin.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: 'Delta One®'
            },
            {
              brandLabel: 'Delta Premium Select',
              targetUrl:
                '/us/en/onboard/onboard-experience/delta-premium-select',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/cabin/delta-premium-cabin.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: 'Delta Premium Select'
            },
            {
              brandLabel: 'Delta First',
              targetUrl: '/us/en/onboard/onboard-experience/delta-first',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/cabin/delta-first-cabin.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: 'Delta First'
            },
            {
              brandLabel: 'Delta Comfort',
              targetUrl: '/us/en/onboard/onboard-experience/delta-comfort',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/cabin/delta-comfort-cabin.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: 'Delta Comfort'
            },
            {
              brandLabel: 'Delta Main',
              targetUrl: '/us/en/onboard/onboard-experience/delta-main',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/cabin/delta-main-cabin.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: 'Delta Main'
            }
          ],
          childPages: [
            {
              pageName: 'Travel Planning Center',
              pageUrl: '/us/en/travel-planning-center/travel-planning-overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Ticket Changes & Refunds',
              pageUrl: '/us/en/change-cancel/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Airline Partners',
              pageUrl: '/us/en/airline-partners/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Baggage',
              pageUrl: '/us/en/baggage/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Check-in & Security',
              pageUrl: '/us/en/check-in-security/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Delta Sky Club®',
              pageUrl: '/us/en/delta-sky-club/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Airport Maps & Locations',
              pageUrl: '/us/en/airports/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Flight Deals',
              pageUrl: '/us/en/flight-deals/current-flight-deals',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Flight Schedules',
              pageUrl: '/flightstatus/search',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Destinations',
              pageUrl: '/us/en/flight-deals/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Onboard Experience',
              pageUrl: '/us/en/onboard/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Delta Cruises',
              pageUrl:
                'https://www.skymilescruises.com/?utm_medium=partner_site_hp_dd&utm_source=dl-delta.com&utm_campaign=2023dl-travelinfo-dd&utm_content=cruisehp',
              openinnewTab: 'true',
              externalimage: 'true'
            },
            {
              pageName: 'Aircraft',
              pageUrl: '/us/en/aircraft/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Delta Vacations',
              pageUrl: '/us/en/delta-vacations',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Delta Car Rentals',
              pageUrl:
                'https://carsandstays.delta.com/initiateSessionValidation?rurl=https%3A%2F%2Fcarsandstays.delta.com%2FCars%3FMDPCID%3DDelta-US.DPS.Delta.GlobalNav-TravelInfo.CAR',
              openinnewTab: 'true',
              externalimage: 'true'
            },
            {
              pageName: 'Delta Stays',
              pageUrl:
                'https://carsandstays.delta.com/initiateSessionValidation?rurl=https%3A%2F%2Fcarsandstays.delta.com%2FHotels%3FMDPCID%3DDelta-US.DPS.Delta.GlobalNav-TravelInfo.STAYS',
              openinnewTab: 'true',
              externalimage: 'true'
            },
            {
              pageName: 'Onboard Wi-Fi',
              pageUrl: '/us/en/onboard/inflight-entertainment/onboard-wifi',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Delta Trip Protection',
              pageUrl:
                'https://www.etravelprotection.com/deltausa/home?utm_source=delta_travel_info_trip_protection&utm_medium=referral&utm_campaign=mobile_travel_insurance',
              openinnewTab: 'true',
              externalimage: 'true'
            }
          ]
        }
      },
      {
        id: 'sky-miles',
        label: 'SkyMiles',
        pagePath: '/en_US/shop-HPR',
        details: {
          mainNavigation: [
            {
              brandLabel: 'Join SkyMiles',
              targetUrl: '/joinskymiles/',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/secondary-nav/delta-logo.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: ''
            },
            {
              brandLabel: 'My SkyMiles',
              targetUrl: '/myskymiles/overview',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/secondary-nav/profile.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: ''
            },
            {
              brandLabel: 'Manage Your Account',
              targetUrl: '/my-profile/personal-details',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/secondary-nav/gear-icon.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: ''
            },
            {
              brandLabel: 'Certificates & eCredits',
              targetUrl: '/redeem-ecredit/',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/secondary-nav/certificate.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: ''
            }
          ],
          childPages: [
            {
              pageName: 'How to Earn Miles',
              pageUrl: '/us/en/skymiles/how-to-earn-miles/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Ways to Redeem Miles',
              pageUrl: '/us/en/skymiles/how-to-use-miles/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Buy or Transfer Miles',
              pageUrl:
                '/us/en/skymiles/how-to-use-miles/buy-gift-transfer-donate-miles',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Travel with Miles',
              pageUrl: '/us/en/skymiles/how-to-use-miles/travel-with-miles',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'SkyMiles Partners & Offers',
              pageUrl:
                '/us/en/skymiles/how-to-earn-miles/skymiles-partners-offers',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'SkyMiles Award Deals',
              pageUrl: '/us/en/flight-deals/skymiles-award-deals',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'SkyMiles Credit Cards',
              pageUrl:
                '/us/en/skymiles/airline-credit-cards/american-express-personal-cards',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'SkyMiles Airline Partners',
              pageUrl: '/us/en/skymiles/how-to-earn-miles/airline-partners',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'SkyMiles Program Overview',
              pageUrl: '/us/en/skymiles/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'How to Get Medallion Status',
              pageUrl: '/us/en/skymiles/medallion-program/how-to-qualify',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Benefits at Each Tier',
              pageUrl: '/us/en/skymiles/medallion-program/medallion-benefits',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'News & Updates',
              pageUrl: 'https://news.delta.com/category/skymiles',
              openinnewTab: 'true',
              externalimage: 'true'
            }
          ]
        }
      },
      {
        id: 'more',
        label: 'Need Help?',
        pagePath: '/en_US/skymiles-HPR',
        details: {
          mainNavigation: [
            {
              brandLabel: 'Change/Cancel Help',
              targetUrl: '/us/en/need-help/support-flights',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/secondary-nav/change-flight.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: 'Help with changing or cancelling a flight'
            },
            {
              brandLabel: 'Request a Refund or Reimbursement',
              targetUrl:
                '/us/en/change-cancel/cancel-flight?refund-reimbursement=true',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/secondary-nav/certificate.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: 'Help with Refunds'
            },
            {
              brandLabel: 'Seats Help',
              targetUrl: '/us/en/need-help/support-seats',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/secondary-nav/seat.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: 'Help with Seats'
            },
            {
              brandLabel: 'Baggage Help',
              targetUrl: '/us/en/baggage/overview',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/secondary-nav/baggage.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: 'Help with Baggage'
            },
            {
              brandLabel: 'Comment/Complaint',
              targetUrl: '/us/en/need-help/overview?commentComplaintsForm',
              svgPathDesktop:
                '/content/dam/delta-applications/ui-kit/assets/svg/secondary-nav/comment.svg',
              openinnewTab: 'false',
              externalimage: 'false',
              altText: 'Help with Comments'
            }
          ],
          childPages: [
            {
              pageName: 'Help Center',
              pageUrl: '/us/en/need-help/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Travel Planning FAQs',
              pageUrl: '/us/en/travel-planning-center/travel-planning-faqs',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Receipts',
              pageUrl: '/us/en/need-help/support-other-information',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Certificates & eCredits',
              pageUrl: '/redeem-ecredit/',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Accessible Travel Services',
              pageUrl: '/us/en/accessible-travel-services/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Child & Infant Travel',
              pageUrl: '/us/en/children-infant-travel/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Pet Travel',
              pageUrl: '/us/en/pet-travel/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Special Circumstances',
              pageUrl: '/us/en/special-circumstances/overview',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'SkyMiles Help',
              pageUrl: '/us/en/need-help/support-skymiles',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Mobile',
              pageUrl: '/us/en/delta-digital/mobile',
              openinnewTab: 'false',
              externalimage: 'false'
            },
            {
              pageName: 'Comment/Complaint',
              pageUrl: '/us/en/need-help/overview?commentComplaintsForm',
              openinnewTab: 'false',
              externalimage: 'false'
            }
          ]
        }
      }
    ],
    auxiliaryNavigation: [
      {
        id: 'signup',
        label: 'signup',
        rightnavLabel: 'Sign Up',
        rightnavLink: '/joinskymiles/',
        signupTooltipLabel: 'Join SkyMiles® for free',
        loginTooltipLabel: ''
      },
      {
        id: 'login',
        label: 'login',
        rightnavLabel: 'Log in',
        rightnavLink: '/login/loginPage?staticurl',
        loginTooltipLabel:
          'Log in to your account for a customized SkyMiles® experience.',
        signupTooltipLabel: ''
      },
      {
        id: 'loggedInMilesLabel',
        loggedInMilesLabel: 'miles',
        loggedInMilesLabelBusiness: 'miles'
      },
      {
        id: 'contactUs',
        contactUsLabel: '',
        contactUsUrl: ''
      },
      {
        id: 'accountrecovery',
        label: 'accountRecovery',
        accountRecoveryToolTipLabel:
          'Add account recovery methods to your SkyMiles profile so if you ever forget your password, you can verify your identity.',
        accountRecoveryToolTipHeader: 'Set Up Account Recovery',
        accountRecoveryLink: 'Add Recovery Methods',
        hideAccountRecoveryTooltip: 'false',
        accountRecoveryNavLink: '/skymiles/emailVerification',
        mfaToolTipDisplayPages: [
          'complete-purchase/confirmation',
          'completepurchase/confirmation'
        ]
      },
      {
        id: 'notification',
        label: 'notification',
        feedLabel: 'Feed',
        advisioriesLabel: 'Advisories',
        advisoriesViewAllLabel: 'View All',
        advisioriesViewAllLink: '/us/en/advisories/current-advisories',
        advisoriesViewNewWindow: 'false',
        newsLabel: 'News',
        newsViewAllLabel: 'View All',
        newsViewAllLink: 'https://news.delta.com/news-archive',
        newsViewNewWindow: 'true',
        notificationLabel: 'Notifications',
        notificationViewAllLabel: 'View All',
        notificationViewAllLink: '/us/en/advisories/current-advisories',
        notificationViewNewTab: 'false',
        noAdvisoriesLabel: 'There are no advisories at this time.',
        noNewsLabel: 'There are no news update at this time.',
        screenReaderViewAllAdvisories:
          'view all advisories Link open in a new tab',
        screenReaderViewAllNews: 'view all news Link open in a new tab',
        screenReaderOpenNewTabLabel: 'Link opens in a new tab',
        screenReaderNotificationAvailableLabel: 'notifications are available',
        loadingLabel: 'Loading...'
      },
      {
        id: 'profileSelector',
        acPickerLogo: '/content/dam/DDCFB/supergraphic-flyout.svg',
        chooseAccountDisplayText: 'Choose a Profile',
        chooseAccountDisclaimer:
          'Regardless of the profile you log into, all miles earned will go towards your SkyMiles account.',
        businessLoginDisplayText: 'Business',
        personalLoginDisplayText: 'Personal',
        businessTravelerDisplayText: 'Business Travel',
        personalTravelerDisplayText: 'Personal Travel',
        CRG3: 'VOEBIZ',
        BBIZ: 'BLUEBIZ',
        CRAM: 'Club Premier Corporate',
        SKYB: 'SKYBONUS',
        adminLoginDisplayText: 'Administration',
        adminLoginUrl: '/edp/adminShowLogin.action',
        nuTravelAdminLoginUrl: '/authvendor/sendSaml.action?agreementId=',
        logOutDisplayText: 'Log Out',
        businessLogoutUrl: '/login/login/logout',
        loginAccountPickerText: 'Which would you like to access?',
        learnMoreText:
          'Learn more about the <a href="/global/en/corporate-travel/business-experience" target="_blank">Business Travel Program</a> and how to manage your program settings. Review <a href="/global/en/corporate-travel/terms-of-use" target="_blank">Terms of Use.</a>'
      },
      {
        id: 'interstitialBanner',
        businessLogo: '/content/dam/DDCFB/business-logo-nosky.svg',
        acSwitchText: 'Switching to your {{CNAME}} business account',
        acSwitchGenericText: 'Switching to your business account',
        progressImageUrl: '/content/dam/DDCFB/Loader.png',
        imageList: [
          {
            deskImage: '/content/dam/DDCFB/Interstitialimage1.png',
            mobileImage: '/content/dam/DDCFB/Mobileimage1.png'
          },
          {
            deskImage: '/content/dam/DDCFB/Interstitialimage2.png',
            mobileImage: '/content/dam/DDCFB/MobileImage2.png'
          },
          {
            deskImage: '/content/dam/DDCFB/Interstitialimage3.png',
            mobileImage: '/content/dam/DDCFB/Mobileimage3.png'
          },
          {
            deskImage: '/content/dam/DDCFB/Interstitialimage4.png',
            mobileImage: '/content/dam/DDCFB/Mobileimage4.png'
          },
          {
            deskImage: '/content/dam/DDCFB/Interstitialimage5.png',
            mobileImage: '/content/dam/DDCFB/Mobileimage5.png'
          }
        ]
      },
      {
        id: 'searchfeed',
        label: 'searchfeed',
        noResultText: 'There are no matches for your search',
        searchLabel: 'Try Asking Me A Question',
        searchFloatingLabel: 'Search for a topic on delta.com',
        popularLabel: 'Popular Topics',
        aiSiteSearchUrl: "'/sitesearch?searchTerm='",
        popularTopics: [
          {
            populartopicsTitle: 'Help Center',
            populartopicsLink: '/us/en/need-help/overview',
            openinnewTab: 'true'
          },
          {
            populartopicsTitle: 'Delta Gift Cards',
            populartopicsLink: '/us/en/gift-cards/overview',
            openinnewTab: 'true'
          },
          {
            populartopicsTitle: 'Baggage',
            populartopicsLink: '/us/en/baggage/overview',
            openinnewTab: 'true'
          },
          {
            populartopicsTitle: 'Pets',
            populartopicsLink: '/us/en/pet-travel/overview',
            openinnewTab: 'true'
          },
          {
            populartopicsTitle: 'Change/Cancel',
            populartopicsLink:
              '/us/en/travel-planning-center/change-or-cancel-your-trip/cancel-change-requirements',
            openinnewTab: 'true'
          },
          {
            populartopicsTitle: 'eCredits',
            populartopicsLink: '/us/en/change-cancel/how-to-rebook',
            openinnewTab: 'true'
          },
          {
            populartopicsTitle: 'Companion',
            populartopicsLink:
              '/us/en/booking-information/companion-certificates',
            openinnewTab: 'true'
          },
          {
            populartopicsTitle: 'SkyMiles',
            populartopicsLink: '/us/en/skymiles/overview',
            openinnewTab: 'true'
          },
          {
            populartopicsTitle: 'Travel Products',
            populartopicsLink: '/us/en/travel-planning-center/travel-products',
            openinnewTab: 'true'
          },
          {
            populartopicsTitle: 'Sky Club',
            populartopicsLink: '/us/en/delta-sky-club/locations',
            openinnewTab: 'true'
          },
          {
            populartopicsTitle: 'Receipts',
            populartopicsLink: '/us/en/need-help/support-other-information',
            openinnewTab: 'true'
          },
          {
            populartopicsTitle: 'Wallet',
            populartopicsLink: '/redeem-ecredit/',
            openinnewTab: 'true'
          }
        ]
      },
      {
        id: 'todayPanel',
        label: 'todayPanel',
        skymilesMember: 'SkyMiles® Member',
        statusLabel: 'Status',
        gateLabel: 'Gate',
        seatLabel: 'Seat',
        checkinLabel: 'Check-In',
        checkinOpenNewTab: 'false',
        viewBoardingPass: 'View Boarding Pass',
        viewBoardingPassOpenNewTab: 'false',
        bookFlightLink: 'Book A Flight',
        myTripsLink: 'Find My Trips',
        depart: 'Departs',
        arrive: 'Arrives',
        operatedby: 'Operated By',
        was: 'Was',
        remainOnFlight: 'Remain On Flight',
        findAlternate: 'Find Alternative Flight',
        findAlternateOpenNewTab: 'false',
        viewTripDetails: 'Trip Details',
        viewTripDetailsOpenNewTab: 'false',
        arrowFlightDetailsOpenNewTab: 'false',
        errormessages: [
          {
            errorId: 'CONF_NUM_REQD',
            errorMessageTitle: 'Please enter a Confirmation Number',
            errorMessageDescription: 'Please enter a Confirmation Number',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'CONF_NUM_INVALID',
            errorMessageTitle: 'Please enter a valid Confirmation Number',
            errorMessageDescription: 'Please enter a valid Confirmation Number',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'TICKET_NUM_REQD',
            errorMessageTitle: 'Please enter a Ticket Number',
            errorMessageDescription: 'Please enter a Ticket Number',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'TICKET_NUM_INVALID',
            errorMessageTitle: 'Please enter a valid Ticket Number',
            errorMessageDescription: 'Please enter a valid Ticket Number',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'CCNUM_REQD',
            errorMessageTitle: 'Please enter a Card Number',
            errorMessageDescription: 'Please enter a Card Number',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'CCNUM_INVALID',
            errorMessageTitle: 'Please enter a valid Card Number',
            errorMessageDescription: 'Please enter a valid Card Number',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'FIRST_NAME_REQD',
            errorMessageTitle: 'Please enter a First Name',
            errorMessageDescription: 'Please enter a First Name',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'FIRST_NAME_INVALID',
            errorMessageTitle: 'Please enter a valid First Name',
            errorMessageDescription: 'Please enter a valid First Name',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'LAST_NAME_REQD',
            errorMessageTitle: 'Please enter a Last Name',
            errorMessageDescription: 'Please enter a Last Name',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'LAST_NAME_INVALID',
            errorMessageTitle: 'Please enter a valid Last Name',
            errorMessageDescription: 'Please enter a valid Last Name',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'FLIGHT_DATE_REQD',
            errorMessageTitle: 'Please enter a Flight Date',
            errorMessageDescription: 'Please enter a Flight Date',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'FLIGHT_NUM_REQD',
            errorMessageTitle:
              'Please enter a valid Flight Number. If you do not know the flight number, please enter the origin and destination.',
            errorMessageDescription:
              'Please enter a valid Flight Number. If you do not know the flight number, please enter the origin and destination.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'FLIGHT_NUM_INVALID',
            errorMessageTitle: 'Please enter a valid Flight Number',
            errorMessageDescription: 'Please enter a valid Flight Number',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'FROM_CITY_REQD',
            errorMessageTitle: 'Please enter a Departure City',
            errorMessageDescription: 'Please enter a Departure City',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'FROM_CITY_INVALID',
            errorMessageTitle: 'Please enter a valid City Code or Airport Name',
            errorMessageDescription:
              'Please enter a valid City Code or Airport Name',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'TO_CITY_REQD',
            errorMessageTitle: 'Please enter a Destination City',
            errorMessageDescription: 'Please enter a Destination City',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'TO_CITY_INVALID',
            errorMessageTitle: 'Please enter a valid City Code or Airport Name',
            errorMessageDescription:
              'Please enter a valid City Code or Airport Name',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'INVALID_FROMTO',
            errorMessageTitle: 'Origin cannot be same as destination',
            errorMessageDescription: 'Origin cannot be same as destination',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'SKYMILES_NUMREQD',
            errorMessageTitle: 'Please enter a SkyMiles Number',
            errorMessageDescription: 'Please enter a SkyMiles Number',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'SKYMILES_NUM_INVALID',
            errorMessageTitle: 'Please enter a valid Skymiles Number',
            errorMessageDescription: 'Please enter a valid Skymiles Number',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'START_DATE_REQD',
            errorMessageTitle: 'Please enter a Departure Date',
            errorMessageDescription: 'Please enter a Departure Date',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'RETURN_DATE_REQD',
            errorMessageTitle: 'Please enter a Return Date',
            errorMessageDescription: 'Please enter a Return Date',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'MULTI_CITY_DATE_INVALID',
            errorMessageTitle:
              'Your Departure Date needs to be before your Return Date',
            errorMessageDescription:
              'Your Departure Date needs to be before your Return Date',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'MEETING_CODE_INVALID',
            errorMessageTitle: 'Please enter a valid Meeting Code',
            errorMessageDescription: 'Please enter a valid Meeting Code',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'IRPD_NO PROT_NO MISCONNECT',
            errorMessageTitle: 'Flight {{flightNumber}} was delayed',
            errorMessageDescription:
              'Your flight has been delayed. You may remain on this flight or find alternate flights at no extra cost.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'IRPD_NO PROT_MISCONNECT',
            errorMessageTitle: 'Flight {{flightNumber}} was delayed',
            errorMessageDescription:
              'Your flight has been delayed and you may miss your connecting flight. You can find alternate flights at no extra cost.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'IRPD_PROT',
            errorMessageTitle: 'Flight {{flightNumber}} was delayed',
            errorMessageDescription:
              "Your flight has been delayed and we rebooked you on another flight. Please click 'Trip Details' to either accept the alternate flight or search for other flight options at no extra cost.",
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'IRP_CLEAN_PAX',
            errorMessageTitle: "You're all set!",
            errorMessageDescription:
              'Your itinerary has been updated with the new flight(s) you selected. You may remain on this flight or find alternate flights at no extra cost.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'IRPC_PROT',
            errorMessageTitle: 'Flight {{flightNumber}} was cancelled',
            errorMessageDescription:
              'Your flight has been cancelled and we rebooked you on another flight. You may remain on this flight or find alternate flights at no extra cost.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'IRPC_NO_PROT',
            errorMessageTitle: 'Flight {{flightNumber}} was cancelled',
            errorMessageDescription:
              "Your flight has been cancelled But don't worry, you can find alternate flights at no extra cost.",
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'IRPD_CLEAN_AUTO',
            errorMessageTitle: 'Flight {{flightNumber}} was delayed',
            errorMessageDescription:
              'Your flight has been delayed and we rebooked you on another flight. You may remain on this flight or find alternate flights at no extra cost.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'IRPC_CLEAN_AUTO',
            errorMessageTitle: 'Flight {{flightNumber}} was cancelled',
            errorMessageDescription:
              'Your flight has been cancelled and we rebooked you on another flight. You may remain on this flight or find alternate flights at no extra cost.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'IROP_EXC',
            errorMessageTitle: 'There has been a change to your trip.',
            errorMessageDescription:
              'Please contact Delta Reservations at 800-221-1212 for assistance.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'IROP_EXC_STN',
            errorMessageTitle: 'There has been a change to your trip.',
            errorMessageDescription:
              'Please contact your local reservation office for assistance.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'IRP_impact',
            errorMessageTitle: 'There has been a change to your trip.',
            errorMessageDescription: 'There has been a change to your trip.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'NO_TRIPS_AVAIL',
            errorMessageTitle:
              'Information will be available 24 hours before your flight.',
            errorMessageDescription:
              'Information will be available 24 hours before your flight.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'SYS_ERROR',
            errorMessageTitle:
              "We're unable to display your trips at this time. Please try again later.",
            errorMessageDescription:
              "We're unable to display your trips at this time. Please try again later.",
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'ACCT_SYS_ERROR',
            errorMessageTitle:
              "We're sorry. We are unable to display your SkyMiles account information. Please try again later.",
            errorMessageDescription:
              "We're sorry. We are unable to display your SkyMiles account information. Please try again later.",
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'UPC_SYS_ERR',
            errorMessageTitle:
              "We're sorry, but we are unable to find your reservation. Please try again later or search below.",
            errorMessageDescription:
              "We're sorry, but we are unable to find your reservation. Please try again later or search below.",
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'DLYD',
            errorMessageTitle: 'There has been a change to your trip.',
            errorMessageDescription: 'There has been a change to your trip.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'CXLD',
            errorMessageTitle: 'There has been a change to your trip.',
            errorMessageDescription: 'There has been a change to your trip.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'FROM_TO_CITY_REQD',
            errorMessageTitle:
              'Origin and destination airports cannot be empty',
            errorMessageDescription:
              'Origin and destination airports cannot be empty',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'START_RETURN_DATE_REQD',
            errorMessageTitle: 'Departure and return dates cannot be empty',
            errorMessageDescription:
              'Departure and return dates cannot be empty',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'AIRPORT_CODE_INVALID',
            errorMessageTitle: 'Please enter a valid city code or airport name',
            errorMessageDescription:
              'Please enter a valid city code or airport name',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'INVALID_CONNECTION_AIRPORT',
            errorMessageTitle:
              "We're sorry, but the connection, departure and destination cities must be different.",
            errorMessageDescription:
              "We're sorry, but the connection, departure and destination cities must be different.",
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'TDY_SYS_ERR',
            errorMessageTitle:
              "We're sorry. Your next trip cannot be displayed at this time. Please try again later.",
            errorMessageDescription:
              "We're sorry. Your next trip cannot be displayed at this time. Please try again later.",
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'ACC_UNAVAILABLE',
            errorMessageTitle: '',
            errorMessageDescription:
              'Your Business profile is currently unavailable due to Technical difficulties. Please reach out to your SAP Concur administrator for details.',
            errorType: '',
            errorCode: '',
            errorMessage: ''
          },
          {
            errorId: 'TDY_IROP_ERROR',
            errorMessageTitle:
              "We apologize for the inconvenience. This service is temporarily unavailable due to technical issues. Please try again later – we're working to resolve this quickly. Thank you for your patience.",
            errorMessageDescription:
              "We apologize for the inconvenience. This service is temporarily unavailable due to technical issues. Please try again later – we're working to resolve this quickly. Thank you for your patience.",
            errorType: '',
            errorCode: '',
            errorMessage: ''
          }
        ]
      },
      {
        id: 'myFlightPanel',
        label: 'myFlightPanel',
        myFlightLabel: 'My Skymiles',
        todayLabel: 'Today',
        feed: 'FEED',
        skymilesLabel: 'SkyMiles #',
        skymilesMember: 'SkyMiles® Member',
        availableMilesLabel: 'Miles Available',
        milesNeverExpire: 'Miles Never Expire',
        medellionStatusDisclaimer:
          'Start Tracking Towards 2026 Medallion Status.*',
        thankYouMessage: 'Thank you for being a valued SkyMiles Member',
        mqmLabel: 'MQMs:',
        mqmAccessibilityLabel: 'MQMs',
        mqsLabel: 'MQSs:',
        mqsAccessibilityLabel: 'MQSs',
        mqdLabel: 'MQDs:',
        mqdAccessibilityLabel: 'MQDs',
        cardSpendAccessibility: 'CARD SPEND',
        miles: 'Miles',
        segments: 'Segments',
        cardSpendLabel: 'CARD SPEND:',
        to: 'TO',
        goTo: 'TO GO',
        currencySymbol: '$',
        mqdWaiver: 'MQD Waiver:',
        medellionStatusDisclaimer2:
          '*You have from January to December 31 Every Year To Qualify For Medallion Status.',
        logoutLabel: 'Log Out',
        logoutUrl: '/login/login/logout',
        sinceLabel: 'Since',
        accountOverview: 'true',
        accountDetails: '',
        silverThreshold: '',
        goldThreshold: '',
        redToSilverMsg: '',
        retainSilverMsg: '',
        silverToGoldMsg: '',
        retainGoldMsg: '',
        achivedGoldMsg: '',
        mySkyMilesLabel: 'My SkyMiles',
        mySkyMilesUrl: '/myskymiles/overview',
        newMySkyMilesUrl: '/myskymiles/overview',
        status: 'Status:',
        myFlightCaretUrl: '/mydelta/dashboard',
        myFlightCaretOpenNewTab: 'false',
        medallion: [
          {
            medallionId: 'FF',
            medallionLabel: 'SkyMiles® Member',
            medallionUrl: '/us/en/skymiles/overview',
            medallionMessage: '',
            tierPointDescription: '',
            tierPointUrl: '',
            medallionDescription: ''
          },
          {
            medallionId: 'FO',
            medallionLabel: 'Silver Medallion®',
            medallionUrl:
              '/us/en/skymiles/medallion-program/silver-medallion-status',
            medallionMessage: '',
            tierPointDescription: '',
            tierPointUrl: '',
            medallionDescription: ''
          },
          {
            medallionId: 'GM',
            medallionLabel: 'Gold Medallion®',
            medallionUrl:
              '/us/en/skymiles/medallion-program/gold-medallion-status',
            medallionMessage: '',
            tierPointDescription: '',
            tierPointUrl: '',
            medallionDescription: ''
          },
          {
            medallionId: 'PM',
            medallionLabel: 'Platinum Medallion®',
            medallionUrl:
              '/us/en/skymiles/medallion-program/platinum-medallion-status',
            medallionMessage: '',
            tierPointDescription: '',
            tierPointUrl: '',
            medallionDescription: ''
          },
          {
            medallionId: 'DM',
            medallionLabel: 'Diamond Medallion®',
            medallionUrl:
              '/us/en/skymiles/medallion-program/diamond-medallion-status',
            medallionMessage: '',
            tierPointDescription: '',
            tierPointUrl: '',
            medallionDescription: ''
          }
        ],
        waiver: [
          {
            waiverLabel: 'Platinum, Gold & Silver MQD Waiver:',
            waiverUrl: '/us/en/skymiles/medallion-program/how-to-qualify',
            waiverPrice: '25K'
          },
          {
            waiverLabel: 'Diamond MQD Waiver:',
            waiverUrl: '/us/en/skymiles/medallion-program/how-to-qualify',
            waiverPrice: '250K'
          }
        ],
        salutation: [
          {
            salutationId: 'goodMorning',
            salutationLabel: 'Good Morning'
          },
          {
            salutationId: 'goodAfternoon',
            salutationLabel: 'Good Afternoon'
          },
          {
            salutationId: 'goodEvening',
            salutationLabel: 'Good Evening'
          }
        ],
        dashboardLabel: 'My Trips',
        dashboardUrl: '/my-trips/upcoming-trips',
        dashboardOpenInNewWindow: 'false',
        profileLabel: 'Profile',
        profileUrl: '/myprofile',
        profileOpenInNewWindow: 'false',
        thankYouMessageMember: 'Thank you for being a ',
        expirationDate: '',
        errorTracker: {
          label: '',
          qualifyUrl: '',
          message: [
            {
              title: '',
              subtitle: ''
            }
          ]
        }
      }
    ],
    disableBusinessHomePage: 'false',
    skipContentButtonLabel: 'Skip to Main Content',
    login: {
      loginScreen: {
        enterPasswordText:
          'Please login to access the full benefits of your selected itinerary. Proceeding without logging in will require you to go back to the flight search results.',
        title: 'Log In To Delta',
        usernameLabel: 'SkyMiles Number or Username',
        passwordLabel: 'Password',
        errorText: 'Login credential is incorrect. Please try again.',
        footer: {
          continueAsGuestText: 'Continue as Guest',
          forgotLoginText: 'Forgot SkyMiles Number',
          forgotLoginViewName: 'forgotLogin',
          forgotPasswordText: 'Forgot Password',
          forgotPasswordViewName: 'resetPassword',
          joinSkyMilesLink: '/joinskymiles/',
          joinSkyMilesText: 'Join Skymiles',
          logOutAndShopAgainText: 'Log Out and Shop Again',
          submitButtonText: 'Log In'
        }
      },
      forgotLoginScreen: {
        identityVerificationText:
          'Need to update your email address? Go to the <a href="/contact-us/identity-verification" class="text-link">ID Verification Form</a> to complete this.',
        title: 'Enter SkyMiles Number Information',
        emailLabel: 'Email Address',
        firstNameLabel: 'First Name',
        lastNameLabel: 'Last Name',
        enterAValidEmailText: 'Enter a valid email address',
        emailRequiredText: 'Email address is required',
        firstNameRequiredText: 'First name is required',
        lastNameRequiredText: 'Last name is required',
        submitButtonText: 'Continue',
        successMessageText:
          'We’ve sent your SkyMiles number to the email address provided.'
      },
      forgotPasswordScreen: {
        title: 'Enter SkyMiles Number Information',
        skymilesNumberLabel: 'SkyMiles Number',
        skymilesNumberPlaceholder: '1234567890',
        skymilesNumberRequiredError: 'SkyMiles number is required',
        skymilesNumberInvalidError: 'Enter a valid SkyMiles number',
        firstNameLabel: 'First Name',
        firstNameRequiredError: 'First name is required',
        firstNameInvalidError: 'Enter a valid first name',
        lastNameLabel: 'Last Name',
        lastNameRequiredError: 'Last name is required',
        lastNameInvalidError: 'Enter a valid last name',
        infoMessage:
          'To continue, please enter the SkyMiles number associated with your account.',
        submitButtonLabel: 'Continue',
        forgotSkymilesNumber: 'Forgot SkyMiles Number'
      },
      addEmailScreen: {
        title: 'Add Email Address',
        buttonText: 'Continue',
        contentBodyHeader:
          'We do not have a valid email address associated with your account. You must provide a valid email address to continue.',
        enterEmailLabel: 'Enter Email Address*',
        enterEmailText: 'Enter Email Address',
        reEnterEmailLabel: 'Re-Enter Email Address*',
        reEnterEmailText: 'Re-Enter Email Address',
        enterAValidEmailText: 'Enter a valid email address',
        emailRequiredText: 'Email address is required',
        emailsDoNotMatchText: 'Emails do not match'
      },
      errors: {
        errorMessages: [
          {
            errorId: 'ERROR_MSG_PAYLOAD_TOO_LARGE',
            errorMessageDescription:
              'Clear your browsing, cookies, and cache data, then log in again.',
            errorMessageTitle: 'PAYLOAD_TOO_LARGE'
          },
          {
            errorId: 'ERROR_MSG_19D2',
            errorMessageDescription: "This SkyMiles account isn't active.",
            errorMessageTitle: 'ACCOUNT_INACTIVE'
          },
          {
            errorId: 'ERROR_MSG_1A89',
            errorMessageDescription:
              'Your account is temporarily locked after sever unsuccessful login attempts. You can reset your password or recover your SkyMiles number to regain access.',
            errorMessageTitle: 'TEMPORARILY_LOCKED'
          },
          {
            errorId: 'ERROR_MSG_1A88',
            errorMessageDescription:
              "We weren't able to log you in. Please check your login details and try again.",
            errorMessageTitle: 'UNABLE_TO_LOGIN'
          },
          {
            errorId: 'ERROR_MSG_1B06',
            errorMessageDescription:
              "Your account is locked to protect your information. To restore access, verify your identity at <a href='/contact-us/identity-verification' class='text-link'>ID Verification Form</a>",
            errorMessageTitle: 'ACCOUNT_LOCKED'
          },
          {
            errorId: 'ERROR_MSG_1A8B',
            errorMessageDescription:
              'For your security, please create a new password.',
            errorMessageTitle: 'ACCOUNT_CREATE_NEW_PASSWORD'
          },
          {
            errorId: 'ERROR_MSG_RESOURCE_NOT_FOUND',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'RESOURCE_NOT_FOUND'
          },
          {
            errorId: 'ERROR_MSG_21',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'UNABLE_TO_PROCESS_REQUEST'
          },
          {
            errorId: 'ERROR_MSG_23',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'UNABLE_TO_PROCESS_REQUEST'
          },
          {
            errorId: 'ERROR_MSG_99',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'UNABLE_TO_PROCESS_REQUEST'
          },
          {
            errorId: 'ERROR_MSG_200',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'UNABLE_TO_PROCESS_REQUEST'
          },
          {
            errorId: 'ERROR_MSG_222',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'UNABLE_TO_PROCESS_REQUEST'
          },
          {
            errorId: 'ERROR_MSG_223',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'UNABLE_TO_PROCESS_REQUEST'
          },
          {
            errorId: 'ERROR_MSG_224',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'UNABLE_TO_PROCESS_REQUEST'
          },
          {
            errorId: 'ERROR_MSG_225',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'UNABLE_TO_PROCESS_REQUEST'
          },
          {
            errorId: 'ERROR_MSG_128',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'GENERIC_EAM_ERROR'
          },
          {
            errorId: 'ERROR_MSG_invalid_grant',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'invalid_grant'
          },
          {
            errorId: 'ERROR_MSG_unsupported_grant_type',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'unsupported grant_type'
          },
          {
            errorId: 'ERROR_MSG_Invalid client_id',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'Invalid client_id'
          },
          {
            errorId: 'ERROR_MSG_client_id is required',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'client_id is required'
          },
          {
            errorId: 'ERROR_MSG_unsupported_response_type',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'unsupported_response_type'
          },
          {
            errorId: 'ERROR_MSG_invalid_request',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'invalid_request'
          },
          {
            errorId: 'ERROR_MSG_UNEXPECTED_ERROR',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'UNEXPECTED_ERROR'
          },
          {
            errorId: 'ERROR_MSG_DEFAULT_ERROR',
            errorMessageDescription:
              "We’re sorry, but login is unavailable right now. You can still book a flight without logging in or manage your upcoming trip in  <a class='text-link' href='/my-trips/search'>My Trips</a>",
            errorMessageTitle: 'default error'
          }
        ]
      }
    }
  },
  footer: {
    search: {
      placeHolder: 'Search for a topic...',
      accessibleTextMsg: 'Search'
    },
    populartopics: {
      heading: 'Popular Topics:',
      popularTopicsList: [
        {
          itemtext: 'Help Center',
          itemUrl: '/us/en/need-help/overview',
          newwindow: 'false'
        },
        {
          itemtext: 'Delta Discover Map',
          itemUrl:
            '/us/en/travel-planning-center/find-your-destination/explore-top-destinations',
          newwindow: 'false'
        },
        {
          itemtext: 'eCredits',
          itemUrl: '/redeem-ecredit/',
          newwindow: 'false'
        }
      ]
    },
    footercolumns: [
      {
        tabcolheading: 'About Delta',
        tabcolItems: [
          {
            tabitemtext: 'About Us',
            tabitemUrl: '/us/en/about-delta/overview',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Careers',
            tabitemUrl: '/us/en/careers/overview',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'News Hub',
            tabitemUrl: 'https://news.delta.com',
            tabnewwindow: 'true',
            externalimage: 'true'
          },
          {
            tabitemtext: 'Investor Relations',
            tabitemUrl: 'https://ir.delta.com/home/default.aspx',
            tabnewwindow: 'true',
            externalimage: 'true'
          },
          {
            tabitemtext: 'Business Travel',
            tabitemUrl: 'https://business.delta.com/DeltaBusiness/s/',
            tabnewwindow: 'true',
            externalimage: 'true'
          },
          {
            tabitemtext: 'Travel Agents',
            tabitemUrl:
              'https://pro.delta.com/content/common/en/agencymap.html',
            tabnewwindow: 'true',
            externalimage: 'true'
          },
          {
            tabitemtext: 'Mobile App',
            tabitemUrl: '/us/en/delta-digital/mobile',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Delta Shop',
            tabitemUrl: 'https://shop.delta.com',
            tabnewwindow: 'true',
            externalimage: 'true'
          }
        ]
      },
      {
        tabcolheading: 'Customer Service',
        tabcolItems: [
          {
            tabitemtext: 'Help Center',
            tabitemUrl: '/us/en/need-help/overview',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Message Us',
            tabitemUrl: '/us/en/need-help/overview#messageUs',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Comment/Complaint',
            tabitemUrl: '/us/en/need-help/overview?commentComplaintsForm',
            tabnewwindow: 'false',
            externalimage: 'false'
          }
        ]
      },
      {
        tabcolheading: 'Site Support',
        tabcolItems: [
          {
            tabitemtext: 'Login Help',
            tabitemUrl: '/us/en/need-help/support-skymiles',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Site Map',
            tabitemUrl: '/us/en/sitemap',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Browser Compatibility',
            tabitemUrl: '/us/en/need-help/browser-compatibility',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Accessibility',
            tabitemUrl: '/us/en/legal/notices/accessibility',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Booking Information',
            tabitemUrl: '/us/en/booking-information/overview',
            tabnewwindow: 'false',
            externalimage: 'false'
          }
        ]
      },
      {
        tabcolheading: 'Policies',
        tabcolItems: [
          {
            tabitemtext: 'Customer Commitment',
            tabitemUrl: '/us/en/legal/customer-commitment',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Tarmac Delay Plan',
            tabitemUrl: '/us/en/legal/plan-for-tarmac-delays',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Legal',
            tabitemUrl: '/us/en/legal/notices/overview',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Sustainability',
            tabitemUrl: '/us/en/about-delta/sustainability',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Contract of Carriage',
            tabitemUrl: '/us/en/legal/contract-of-carriage-dgr',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Cookies, Privacy & Security',
            tabitemUrl: '/us/en/legal/privacy-and-security',
            tabnewwindow: 'false',
            externalimage: 'false'
          },
          {
            tabitemtext: 'Combatting Modern Slavery (PDF)',
            tabitemUrl:
              '/content/dam/delta-www/pdfs/combatting-modern-slavery.pdf',
            tabnewwindow: 'true',
            externalimage: 'false'
          }
        ]
      }
    ],
    info: {
      copyright: '© 2026 Delta Air Lines, Inc.',
      disclaimer1: 'Travel may be on other airlines.<br />\r\n\r\n\r\n',
      disclaimer2:
        'Terms and conditions apply to all offers and SkyMiles benefits. See specific offer for details, and visit <a href="/us/en/skymiles/program-resources/program-rules" target="_self" title="SkyMiles Membership Guide &amp; Program Rules">SkyMiles Membership Guide &amp; Program Rules</a><br />\r\n',
      footerExtDesc:
        'This link opens another site in a new window that may not follow the same accessibility policies as Delta Air Lines.',
      externalImgPath:
        '/content/dam/delta-com/external-link-images/external-icon.svg',
      footerTextImgPath:
        '/content/dam/delta-com/external-link-images/footer-Text-External-Link.svg',
      isShowFooterNote: 'true'
    },
    socialIcons: [
      {
        iconLogo:
          '/content/dam/delta_homepage_redesign/hpr_optimized_images/social_icons/logo-meta-47.png',
        iconLink: 'https://www.facebook.com/delta',
        openinnewTab: 'true',
        iconAlt: 'Facebook',
        openExternalLinkModal: 'false'
      },
      {
        iconLogo:
          '/content/dam/delta_homepage_redesign/hpr_optimized_images/social_icons/logo-x-47.png',
        iconLink: 'https://www.x.com/delta',
        openinnewTab: 'true',
        iconAlt: 'X',
        openExternalLinkModal: 'false'
      }
    ],
    feedback: {},
    countrylanguage: {
      id: 'countrylanguage',
      defaultCountry: '',
      headingText: 'Select Your Country / Region and Language',
      country: 'Country / Region',
      language: 'Language',
      done: 'Done',
      supportedCountry: ''
    },
    additionalInfo: [
      {
        info: 'Delta Air Lines, Inc. Korea Branch  |  Representative:  KIM SEONG SU   |   Address: 4th Floor, Room 3207, 446 Je2terminal-daero, Jung-gu, Incheon, South Korea  |  Seoul Tel: <a href="tel:8223175502">82-2-317-5502</a> |  E-mail: <a href="mailto:Andrew.kim@delta.com">Andrew.kim@delta.com</a><br>Business Registration Number: 104-84-03366 |  E-commerce Registration Number: 2013-Seoul Junggu-1032 | <a href="https://ftc.go.kr/www/biz/bizCommView.do?key=5375&amp;apv_perm_no=2013301013030200692&amp;pageUnit=10&amp;searchCnd=wrkr_no&amp;searchKrwd=1048403366&amp;pageIndex=1\\" target="_blank">Information Disclosure Page Posted on KFTC Homepage</a> |  Hosting Service Provider: Delta Air Lines, Inc.',
        countryCode: 'kr'
      }
    ]
  },
  advisories: {
    AdvisoriesList: [
      {
        title: 'Montego Bay Infrastructure',
        Description:
          'Due to the infrastructure impact caused by Hurricane Melissa, travel to/from/through the Montego Bay area through Jan. 15, 2026, may be impacted.',
        pageurl: '/us/en/advisories/other-alerts/montego-bay-infrastructure',
        timestamp: 'Dec. 9, 2025 at 04:00 PM ET'
      },
      {
        title: 'Israel Electronic Travel Authorization',
        Description:
          'As of January 1, 2025, all passport holders from visa-exempt nations, including the U.S., must show an electronic travel authorization to enter Israel.',
        pageurl:
          '/us/en/advisories/other-alerts/israel-electronic-travel-authorization',
        timestamp: 'Sep. 27, 2025 at 08:26 AM ET'
      },
      {
        title: 'Brazil eVisa Requirement',
        Description:
          'United States, Australian and Canadian passport holders now require an eVisa for Brazil (unless you have a valid physical visa).',
        pageurl: '/us/en/advisories/other-alerts/brazil-evisa-requirement',
        timestamp: 'Nov. 14, 2025 at 01:00 PM ET'
      }
    ]
  },
  applicationadvisories: {
    viewAllAdvisoriesLabel: ' ',
    advisoriesNewWindow: 'false',
    defaultDisplay: 'false',
    overrideAutomatedAlert: 'false',
    iconClassName: '',
    hexColorCode: '',
    overrideLinkLabel: '',
    overrideLink: '',
    linkInNewWindow: 'false',
    hideCloseButton: 'false',
    ApplicationAdvisoriesList: [
      {
        title:
          '<strong>FAA Directive</strong><br>\r\nDelta is reducing flights at 40 US airports to comply with federal directives. All planned cancellations for Nov. 7-8 have been completed. <a href="https://www.delta.com/us/en/advisories/other-alerts/faa-directive" style="font-weight: 600;">Explore options</a> to change or cancel flights without penalty.',
        apptype: 'home',
        advisoryKey: '202509190145',
        pageUrl: '/us/en/advisories/coronavirus-travel'
      }
    ]
  },
  darkSite: {
    isEnabled: 'false',
    level: 'level0',
    enableBlackTheme: 'false'
  },
  sessionTimeoutMessage: {
    id: 'sessionTimeout',
    sessionTimeoutMessageTitle: 'Your Session Is About To Expire',
    sessionTimeoutMessageDescription:
      'For security and protection of your personal data, you will be logged out in {{minutes}} minutes and {{seconds}} seconds. Would you like to stay logged in?',
    logOutText: 'No, Log Me Out',
    loggedInText: 'Yes, Extend My Session',
    expiryTime: '300'
  },
  logo: {
    mainLogo: '/content/dam/delta_homepage_redesign/Logo/Delta-Logo.svg',
    mainLogoUrl: '/',
    mainLogoAltText: 'Delta Air Lines',
    mainLogoNewTab: 'false',
    subLogo: '/content/dam/delta_homepage_redesign/Logo/Sky Team.svg',
    subLogoUrl: 'https://www.skyteam.com',
    subLogoAltText: 'Skyteam',
    subLogoNewTab: 'true',
    busiLogo: '/content/dam/DDCFB/business-logo-nosky.svg',
    busiLogoUrl: '/',
    busiLogoAltText: 'Delta Business Logo',
    busiLogoNewTab: 'false',
    slimheaderLogo: '/content/dam/delta_homepage_redesign/Logo/Delta-Logo.svg',
    slimheaderLogoUrl: '/us/en/delta-vacations',
    slimheaderLogoAltText: '',
    slimheaderLogoNewTab: 'false',
    title: '',
    subLogoExtLinkPopup: 'false',
    supergraphicDeltaMarkDarksite:
      'content/dam/delta_homepage_redesign/Logo/supergraphic-delta-mark-darksite.svg',
    supergraphicDeltaMark:
      'content/dam/delta_homepage_redesign/Logo/supergraphic-flyout.svg'
  },
  unsupportedBrowserPopup: {
    id: 'BrowserPopup',
    heading: 'Unsupported Browser',
    title: 'Upgrade for a better experience',
    browserDescription:
      'To get most of delta.com upgrade your browser for free.',
    ctaLabel: 'CONTINUE TO DELTA.COM',
    ctaUrl: '/',
    disclaimerText: "Don't care to upgrade",
    footnoteTitle: 'Why is my browser no longer supported?',
    footnoteDescription:
      'It doesn’t have the same features as today’s modern browsers. Supporting older browser prevents us from delivering improvements that benefit most delta.com users. <a href="/en_US/support/browser-compatibility" target="_blank">See the complete list of the browser we support</a>.',
    browserIconValues: [
      {
        browserIconLogo:
          '/content/dam/delta_homepage_redesign/hpr_optimized_images/unsupported_browser/firefox.svg',
        browserIconLink: 'https://www.mozilla.org/en-US/firefox/new/',
        browserIconTarget: 'true',
        iconText: 'Firefox'
      },
      {
        browserIconLogo:
          '/content/dam/delta_homepage_redesign/hpr_optimized_images/unsupported_browser/safari.svg',
        browserIconLink: 'https://www.apple.com/safari/download/',
        browserIconTarget: 'true',
        iconText: 'Safari'
      },
      {
        browserIconLogo:
          '/content/dam/delta_homepage_redesign/hpr_optimized_images/unsupported_browser/chrome.svg',
        browserIconLink: 'https://www.google.com/chrome',
        browserIconTarget: 'true',
        iconText: 'Chrome'
      },
      {
        browserIconLogo:
          '/content/dam/delta_homepage_redesign/hpr_optimized_images/unsupported_browser/edge.svg',
        browserIconLink: 'https://www.microsoft.com/en-us/edge/download',
        browserIconTarget: 'true',
        iconText: 'Edge'
      }
    ]
  }
};
